import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import LatestUpdates from './components/LatestUpdates';
import PopularSidebar from './components/PopularSidebar';
import FAQSection from './components/FAQSection';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const homeSchema = [
    {
      '@context': 'https://schema.org',
      '@type': 'WebPage',
      name: '韩漫大全 - 好看韩国漫画免费在线阅读',
      description: '韩漫漫画网站通过此漫画网址提供韩漫大全与好看韩国漫画的免费在线阅读，资源稳定更新及时。',
      url: 'https://hanmandq.com',
      isPartOf: {
        '@type': 'WebSite',
        name: '韩漫大全',
        url: 'https://hanmandq.com',
      },
      about: {
        '@type': 'Thing',
        name: '韩国漫画',
        description: '提供韩国漫画免费在线阅读服务',
      },
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: '韩漫大全是什么？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '韩漫大全是一个专注于韩国漫画在线阅读的综合平台，为广大华语读者提供最新最全最高质量的韩国漫画资源。',
          },
        },
        {
          '@type': 'Question',
          name: '韩漫大全上的漫画都是免费的吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '是的，韩漫大全上的所有韩国漫画资源均完全免费提供在线阅读，无需付费无需订阅。',
          },
        },
        {
          '@type': 'Question',
          name: '韩漫大全的更新频率如何？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '编辑团队每日跟进韩国漫画的最新动态，确保热门连载漫画第一时间更新到网站。',
          },
        },
        {
          '@type': 'Question',
          name: '如何找到想看的特定漫画？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '可通过搜索功能、分类页面或首页热门排行榜和最新更新列表查找漫画。',
          },
        },
        {
          '@type': 'Question',
          name: '韩漫大全支持手机阅读吗？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '韩漫大全采用响应式设计，完美适配手机、平板和电脑等各种设备。',
          },
        },
        {
          '@type': 'Question',
          name: '为什么有些漫画只更新了一部分？',
          acceptedAnswer: {
            '@type': 'Answer',
            text: '韩国漫画以连载形式发布，翻译团队紧跟韩文原版更新进度，以最快速度带来最新内容。',
          },
        },
      ],
    },
  ];

  return (
    <>
      <SEOHead
        title="韩漫大全_好看的韩国漫画_漫画韩漫网址_免费韩漫在线阅读-韩漫漫画网站"
        description="韩漫漫画网站通过此漫画网址提供韩漫大全与好看韩国漫画的免费在线阅读，资源稳定更新及时。汇集热门韩国漫画，每日更新，提供流畅的在线阅读体验。"
        keywords="韩漫大全,好看韩国漫画,漫画网址,免费在线阅读,韩漫漫画网站"
        canonicalUrl="https://hanmandq.com"
        schemaData={homeSchema}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryTabs />
        <LatestUpdates />
        <PopularSidebar />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}